import { render, staticRenderFns } from "./VimeoPlayerWithControls.vue?vue&type=template&id=00064581&scoped=true&"
import script from "./VimeoPlayerWithControls.vue?vue&type=script&lang=js&"
export * from "./VimeoPlayerWithControls.vue?vue&type=script&lang=js&"
import style0 from "./VimeoPlayerWithControls.vue?vue&type=style&index=0&id=00064581&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00064581",
  null
  
)

export default component.exports